import React from "react";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import type { PickerValue } from "@mui/x-date-pickers/internals";
import dayjs from "dayjs";

const maxDate = new Date();
export default function DateRange({
  displayErrors,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled,
  minDate = new Date(2018, 0),
}: {
  displayErrors: boolean;
  startDate: Date | undefined;
  endDate: Date | undefined;
  onStartDateChange: (date: Date | undefined) => void;
  onEndDateChange: (date: Date | undefined) => void;
  disabled: boolean;
  minDate: Date;
}) {
  const startDateError = displayErrors && (!startDate || startDate < minDate);
  const endDateError = () => {
    if (!displayErrors) return false;
    if (!endDate) return true;
    return startDate && endDate < startDate;
  };

  function handleStartDate(date: PickerValue) {
    onStartDateChange(date === null ? undefined : date.toDate());
    if (!endDate || !date) {
      return;
    }
    // remove the endDate if the new Start date is newer than endDate
    const newStartDate = date.toDate().getTime();
    if (newStartDate > endDate.getTime()) {
      onEndDateChange(undefined);
    }
  }

  function handleEndDate(date: PickerValue) {
    onEndDateChange(date === null ? undefined : date.toDate());
  }

  return (
    <div className="date-range">
      <DesktopDatePicker
        disabled={disabled}
        label={"Start Date"}
        maxDate={dayjs(maxDate)}
        minDate={dayjs(minDate)}
        onChange={handleStartDate}
        slotProps={{
          textField: {
            inputProps: {
              "data-testid": "DateRange-startDate",
            },
            required: true,
            error: startDateError,
          },
        }}
        value={dayjs(startDate)}
      />
      <ChevronRightOutlinedIcon className="icon" />
      <DesktopDatePicker
        disabled={disabled}
        label={"End Date"}
        maxDate={dayjs(maxDate)}
        minDate={dayjs(minDate)}
        onChange={handleEndDate}
        slotProps={{
          textField: {
            inputProps: {
              "data-testid": "DateRange-endDate",
            },
            required: true,
            error: endDateError(),
          },
        }}
        value={dayjs(endDate)}
      />
    </div>
  );
}
